export const SET_ENTITY_TYPE = "@DIALOG_COMPONENTS/ENTITY_TYPE/SET_ENTITY_TYPE";
